import { css } from 'css-literal-loader/styled';
import React from 'react';

import Spinner from './Spinner';

const styles = require('./LoadingIndicator-styles.module.scss');

export default function LoadingIndicator(props) {
  return (
    <div {...props} className={styles.container}>
      <Spinner className={styles.spinner} />
    </div>
  );
}
